var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import axios from 'axios';
import FrameFilters from 'components/standard-size-picture-frames/FrameFilters.vue';
import FrameResults from 'components/standard-size-picture-frames/FrameResults.vue';
let ToFit = class ToFit extends Vue {
    constructor() {
        super(...arguments);
        this.size = null;
        this.filters = {
            styleRating: 5,
            widthRange: [5, 130],
            colourId: null,
            mountType: 'single',
            mountWidth: 40,
            mountColour: null,
            sortBy: 'favourites',
            order: 'asc'
        };
    }
    created() {
        let hiddenInput = document.getElementById('size');
        const size = hiddenInput === null || hiddenInput === void 0 ? void 0 : hiddenInput.value;
        // Get the size
        axios
            .get('/api/sizes/byUrlName', { params: { name: size } })
            .then(({ data }) => this.size = { width: data.width_mm, length: data.height_mm });
        axios
            .get('/api/materials/mountboard/bySku', { params: { sku: '8001' } })
            .then(({ data }) => this.filters.mountColour = data);
    }
};
ToFit = __decorate([
    Component({
        components: {
            FrameFilters, FrameResults
        }
    })
], ToFit);
export default ToFit;
